import { labeled, stringOptional } from '../../util/joi';

export const schema = (Joi: any, label: string) =>
  Joi.object().keys({
    id: stringOptional(Joi, 1, 8).label(labeled(label, 'Code'))
  });

export default {
  schema
};
